document.addEventListener('DOMContentLoaded', function() {
  // Initialize all image grid galleries on the page
  const imageGridSections = document.querySelectorAll('[data-wetheme-section-type="image--grid-gallery"]');
  
  imageGridSections.forEach(function(section) {
    initializeImageGridGallery(section);
  });
});

function initializeImageGridGallery(section) {
  const sectionId = section.getAttribute('data-wetheme-section-id');
  const modal = document.getElementById(`image-grid-modal-${sectionId}`);
  
  if (!modal) {
    console.error('Modal not found for section:', sectionId);
    return;
  }
  
  const modalOverlay = modal.querySelector('.image-grid-modal-overlay');
  const modalClose = modal.querySelector('.image-grid-modal-close');
  const modalImage = modal.querySelector('.modal-image');
  const modalVideoContainer = modal.querySelector('.modal-video-container');
  let modalVideo = modal.querySelector('.modal-video');
  const modalDescription = modal.querySelector('.modal-description');
  const modalUsername = modal.querySelector('.modal-username');
  const modalDate = modal.querySelector('.modal-date');
  const modalReadMoreContainer = modal.querySelector('.modal-read-more-container');
  const modalReadMoreLink = modal.querySelector('.modal-read-more-link');
  
  // Get all grid items
  const gridItems = section.querySelectorAll('.image-grid-item-inner');
  
  // The deferred-media component will handle video loading automatically
  // No need for manual video loading since we're using the proper deferred-media component
  
  // Function to open modal
  function openModal(item) {
    if (!modal || !modalDescription) {
      return;
    }
    
    const imageUrl = item.dataset.imageUrl || '';
    const videoUrl = item.dataset.videoUrl || '';
    let mediaType = item.dataset.mediaType || 'image';
    const title = item.dataset.title || '';
    const subtitle = item.dataset.subtitle || '';
    const username = item.dataset.username || '';
    const date = item.dataset.date || '';
    const videoType = item.dataset.videoType || '';
    const readMoreText = item.dataset.readMoreText || '';
    const readMoreLink = item.dataset.readMoreLink || '';
    
    // Check if this is a video item and trigger deferred media loading
    const deferredMedia = item.querySelector('.deferred-media');
    if (deferredMedia && !deferredMedia.classList.contains('loaded')) {
      const loadButton = deferredMedia.querySelector('.deferred-media__poster-button');
      if (loadButton) {
        loadButton.click();
      }
    }
    
    const isValidVideoUrl = videoUrl && 
                            videoUrl.trim() !== '' && 
                            videoUrl !== 'undefined' && 
                            videoUrl !== 'null' &&
                            videoUrl.length > 0;
    
    if (mediaType === 'video' && !isValidVideoUrl) {
      mediaType = 'image';
    }
    
    if (mediaType === 'video' && isValidVideoUrl && videoUrl) {
      console.log('Attempting to show video in modal:', videoUrl);
      console.log('Video URL type:', typeof videoUrl);
      console.log('Video URL length:', videoUrl.length);
      
      modalImage.style.display = 'none';
      modalVideoContainer.style.display = 'block';
      
      const originalVideo = item.querySelector('video');
      const originalIframe = item.querySelector('iframe');
      const originalDeferredMedia = item.querySelector('.deferred-media');
      
      console.log('Original video element:', originalVideo);
      console.log('Original iframe element:', originalIframe);
      console.log('Original deferred media element:', originalDeferredMedia);
      
      if (videoType === 'uploaded' && originalVideo) {
        console.log('Found uploaded video element, using its source:', originalVideo.src);
        const videoSource = modalVideo.querySelector('source');
        if (videoSource) {
          // For uploaded videos, we need to get the actual video URL
          const videoUrl = originalVideo.src || originalVideo.currentSrc;
          if (videoUrl) {
            videoSource.src = videoUrl;
            modalVideo.load();
            modalVideo.muted = false;
            modalVideo.controls = true;
            modalVideo.preload = 'metadata';
            modalVideo.playsinline = true;
            modalVideo.play().catch(function(error) {
              console.log('Video play failed:', error);
              modalVideo.controls = true;
            });
          } else {
            console.log('No video URL found in uploaded video element');
            handleDirectVideoUrl(videoUrl);
          }
        }
      } else if (videoType === 'external' && originalIframe && originalIframe.src) {
        console.log('Found iframe, creating new iframe in modal:', originalIframe.src);
        modalVideoContainer.innerHTML = '';
        const newIframe = document.createElement('iframe');
        newIframe.src = originalIframe.src;
        newIframe.style.width = '100%';
        newIframe.style.height = '100%';
        newIframe.style.border = 'none';
        newIframe.allowFullscreen = true;
        modalVideoContainer.appendChild(newIframe);
      } else if (originalDeferredMedia) {
        console.log('Found deferred media element, trying to extract video source');
        const deferredVideo = originalDeferredMedia.querySelector('video');
        const deferredIframe = originalDeferredMedia.querySelector('iframe');
        
        if (videoType === 'uploaded' && deferredVideo) {
          console.log('Found uploaded video in deferred media:', deferredVideo.src);
          const videoSource = modalVideo.querySelector('source');
          if (videoSource) {
            // For uploaded videos in deferred media, get the actual video URL
            const videoUrl = deferredVideo.src || deferredVideo.currentSrc;
            if (videoUrl) {
              videoSource.src = videoUrl;
              modalVideo.load();
              modalVideo.muted = false;
              modalVideo.controls = true;
              modalVideo.preload = 'metadata';
              modalVideo.playsinline = true;
              modalVideo.play().catch(function(error) {
                console.log('Video play failed:', error);
                modalVideo.controls = true;
              });
            } else {
              console.log('No video URL found in deferred uploaded video, trying direct URL');
              handleDirectVideoUrl(videoUrl);
            }
          }
        } else if (videoType === 'uploaded') {
          // Try to get video URL from the deferred media data attributes or source elements
          const videoSourceElement = originalDeferredMedia.querySelector('source');
          if (videoSourceElement && videoSourceElement.src) {
            console.log('Found video source element in deferred media:', videoSourceElement.src);
            const videoSource = modalVideo.querySelector('source');
            if (videoSource) {
              videoSource.src = videoSourceElement.src;
              modalVideo.load();
              modalVideo.muted = false;
              modalVideo.controls = true;
              modalVideo.preload = 'metadata';
              modalVideo.playsinline = true;
              modalVideo.play().catch(function(error) {
                console.log('Video play failed:', error);
                modalVideo.controls = true;
              });
            }
          } else {
            console.log('No video source found in deferred media, trying direct URL');
            handleDirectVideoUrl(videoUrl);
          }
        } else if (videoType === 'external' && deferredIframe && deferredIframe.src) {
          console.log('Found external video iframe in deferred media:', deferredIframe.src);
          modalVideoContainer.innerHTML = '';
          const newIframe = document.createElement('iframe');
          newIframe.src = deferredIframe.src;
          newIframe.style.width = '100%';
          newIframe.style.height = '100%';
          newIframe.style.border = 'none';
          newIframe.allowFullscreen = true;
          modalVideoContainer.appendChild(newIframe);
        } else {
          console.log('No video found in deferred media, trying direct URL');
          handleDirectVideoUrl(videoUrl);
        }
      } else {
        console.log('No original video/iframe/deferred media found, trying to use video URL directly');
        // For uploaded videos, try to construct the video URL if it's not already a full URL
        if (videoType === 'uploaded' && videoUrl && !videoUrl.startsWith('http')) {
          // This might be a relative path or video ID, try to construct the full URL
          const fullVideoUrl = videoUrl.startsWith('/') ? videoUrl : `/${videoUrl}`;
          console.log('Constructed full video URL for uploaded video:', fullVideoUrl);
          handleDirectVideoUrl(fullVideoUrl);
        } else {
          handleDirectVideoUrl(videoUrl);
        }
      }
      
      function handleDirectVideoUrl(url) {
        console.log('Handling direct video URL:', url);
        
        // Check if it's a YouTube URL and convert to embed URL
        if (url.includes('youtube.com') || url.includes('youtu.be')) {
          console.log('YouTube URL detected, creating iframe');
          modalVideoContainer.innerHTML = '';
          
          // Convert YouTube URL to embed URL
          let embedUrl = url;
          if (url.includes('youtube.com/watch?v=')) {
            const videoId = url.split('v=')[1].split('&')[0];
            embedUrl = `https://www.youtube.com/embed/${videoId}`;
          } else if (url.includes('youtu.be/')) {
            const videoId = url.split('youtu.be/')[1].split('?')[0];
            embedUrl = `https://www.youtube.com/embed/${videoId}`;
          }
          
          const iframe = document.createElement('iframe');
          iframe.src = embedUrl;
          iframe.style.width = '100%';
          iframe.style.height = '100%';
          iframe.style.border = 'none';
          iframe.allowFullscreen = true;
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
          modalVideoContainer.appendChild(iframe);
        } else if (url.includes('vimeo.com')) {
          console.log('Vimeo URL detected, creating iframe');
          modalVideoContainer.innerHTML = '';
          
          // Convert Vimeo URL to embed URL
          let embedUrl = url;
          if (url.includes('vimeo.com/')) {
            const videoId = url.split('vimeo.com/')[1].split('?')[0];
            embedUrl = `https://player.vimeo.com/video/${videoId}`;
          }
          
          const iframe = document.createElement('iframe');
          iframe.src = embedUrl;
          iframe.style.width = '100%';
          iframe.style.height = '100%';
          iframe.style.border = 'none';
          iframe.allowFullscreen = true;
          modalVideoContainer.appendChild(iframe);
        } else {
          // Handle direct video files
          const videoSource = modalVideo.querySelector('source');
          if (videoSource) {
            videoSource.src = '';
            modalVideo.load();
            videoSource.src = url;
            modalVideo.muted = false;
            modalVideo.controls = true;
            modalVideo.preload = 'metadata';
            modalVideo.playsinline = true;
            modalVideo.load();
            modalVideo.addEventListener('loadeddata', function() {
              console.log('Video loaded, attempting to play');
              modalVideo.play().catch(function(error) {
                console.log('Video play failed:', error);
                modalVideo.controls = true;
              });
            }, { once: true });
            modalVideo.addEventListener('error', function(e) {
              console.log('Video error:', e);
              console.log('Video error details:', modalVideo.error);
              modalVideoContainer.style.display = 'none';
              modalImage.style.display = 'block';
              if (imageUrl) {
                modalImage.src = imageUrl;
              }
            });
          } else {
            console.log('No video source element found in modal');
          }
        }
      }
    } else {
      modalVideoContainer.style.display = 'none';
      modalImage.style.display = 'block';
      if (imageUrl) {
        modalImage.src = imageUrl;
      } else {
        const clickedImage = item.querySelector('img');
        if (clickedImage && clickedImage.src) {
          modalImage.src = clickedImage.src;
        } else {
          modalImage.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjRjVGNUY1Ii8+Cjx0ZXh0IHg9IjEwMCIgeT0iMTAwIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTQiIGZpbGw9IiM5OTk5OTkiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5ObyBJbWFnZTwvdGV4dD4KPC9zdmc+';
        }
      }
    }
    
    modalImage.alt = title;
    if (modalUsername) {
      modalUsername.textContent = username || 'primallypure';
    }
    if (modalDate) {
      modalDate.textContent = date || '02/08/25';
    }
    let description = '';
    if (title && subtitle) {
      description = `${title} - ${subtitle}`;
    } else if (title) {
      description = title;
    } else if (subtitle) {
      description = subtitle;
    } else {
      description = 'A decade of pure goodness! 💜 We\'re still celebrating with our Limited-Edition Birthday Box.';
    }
    modalDescription.textContent = description;
    
    // Handle read more link
    if (readMoreLink && readMoreLink.trim() !== '' && readMoreLink !== 'undefined' && readMoreLink !== 'null' && readMoreText && readMoreText.trim() !== '') {
      modalReadMoreLink.href = readMoreLink;
      modalReadMoreLink.textContent = readMoreText;
      modalReadMoreContainer.style.display = 'block';
    } else {
      modalReadMoreContainer.style.display = 'none';
    }
    
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  
  function closeModal() {
    modal.classList.remove('active');
    document.body.style.overflow = '';
    
    // Stop modal video
    if (modalVideo) {
      modalVideo.pause();
      modalVideo.currentTime = 0;
    }
    
    // Stop any iframe videos in modal
    const modalIframes = modalVideoContainer.querySelectorAll('iframe');
    modalIframes.forEach(iframe => {
      if (iframe.src) {
        // For YouTube videos, we need to reload the iframe to stop them
        const currentSrc = iframe.src;
        iframe.src = '';
        iframe.src = currentSrc;
      }
    });
    
    // Clear modal video container content
    modalVideoContainer.innerHTML = '';
    
    // Recreate the video element
    const newVideo = document.createElement('video');
    newVideo.className = 'modal-video';
    newVideo.controls = true;
    newVideo.preload = 'metadata';
    newVideo.playsinline = true;
    const source = document.createElement('source');
    source.src = '';
    source.type = 'video/mp4';
    newVideo.appendChild(source);
    newVideo.appendChild(document.createTextNode('Your browser does not support the video tag.'));
    modalVideoContainer.appendChild(newVideo);
    
    // Update the modalVideo reference to the new element
    modalVideo = newVideo;
  }
  
  gridItems.forEach(item => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const clickAction = item.dataset.clickAction || 'popup';
      const blockLink = item.dataset.blockLink || '';
      
      if (clickAction === 'link' && blockLink && blockLink.trim() !== '' && blockLink !== 'undefined' && blockLink !== 'null') {
        // Redirect to the specified link
        window.open(blockLink, '_blank');
      } else {
        // Open popup (default behavior)
        openModal(item);
      }
    });
  });
  
  modalOverlay.addEventListener('click', closeModal);
  modalClose.addEventListener('click', closeModal);
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });
} 